
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20.738","height":"21.614"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.606 17.292h.117l5.637-1.227a.555.555 0 00.292-.146l9.552-9.551a3.681 3.681 0 001.08-2.629 3.8 3.8 0 00-1.08-2.658A3.68 3.68 0 0014.575 0a3.593 3.593 0 00-2.631 1.111l-9.52 9.551a.526.526 0 00-.175.263l-1.227 5.637a.643.643 0 00.175.555.584.584 0 00.409.175zM14.575 1.169a2.541 2.541 0 012.541 2.541v.029a2.454 2.454 0 01-.73 1.782L12.793 1.9a2.512 2.512 0 011.782-.731zm-2.6 1.577l3.593 3.593-8.324 8.3-3.593-3.563zm-8.791 9.493l2.892 2.892-3.709.818zM20.154 20.446H.584a.584.584 0 100 1.168h19.57a.584.584 0 100-1.168z","fill":"#303030"}})])
          )
        }
      }
    